// Shared category label map — single source of truth used by Header, Shop, Admin everywhere
export const CATEGORY_LABELS = {
  LED_LIGHTS:      'LED Lights',
  SWITCHES:        'Switches',
  WIRES_CABLES:    'Wires & Cables',
  FANS:            'Fans',
  INVERTER:        'Inverters & UPS',
  TOOLS:           'Tools',
  APPLIANCES:      'Appliances',
  ACCESSORIES:     'Accessories',
  SERVICE:         'Services',
  CIRCUIT_BREAKERS:'Circuit Breakers',
  HEATERS:         'Heaters',
  PANELS_BOARDS:   'Panels & Boards',
  PLUGS_SOCKETS:   'Plugs & Sockets',
  EXHAUST_FANS:    'Exhaust Fans',
  WATER_HEATERS:   'Water Heaters',
  STABILIZERS:     'Stabilizers',
  METERS:          'Meters',
};

/** Converts a raw API category _id to its display label */
export function categoryLabel(id) {
  return CATEGORY_LABELS[id] || (id || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
